import script from "./MyJsonDisplayer.vue?vue&type=script&setup=true&lang=js"
export * from "./MyJsonDisplayer.vue?vue&type=script&setup=true&lang=js"

import "./MyJsonDisplayer.vue?vue&type=style&index=0&id=ef11a58c&lang=scss&scoped=true"

import exportComponent from "/opt/streamify/admin/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef11a58c"]])

export default __exports__